<template lang="pug">
  v-dialog(v-model="show" persistent fullscreen scrollable)
    v-snackbar( v-model="snackbar" :color="snackbarColor" ) {{ snackbarMessage }}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs"
          @click="snackbar = false") {{ $t('buttons.closeButtonLabel') }}
    v-card
      v-card-title {{ $t('addBoarderDialog.boarderLabel') }}
      v-card-text
        v-col(cols="12" v-if="selectedBoarder")
          v-form(ref="form" v-model="isForm2Valid" lazy-validation)
            v-row
              v-col(cols="12")
                v-text-field(
                  v-model="selectedBoarder.person.firstName + ' ' + selectedBoarder.person.familyName"
                  :label="$t('addBoarderDialog.nameFieldLabel')" outlined prepend-icon="fas fa-user"
                  readonly
                )
            v-row
              v-col.pb-0(cols="12")
                v-select(
                  v-model="customer"
                  append-icon="fas fa-chevron-down" :label="$t('addBoarderDialog.customerFieldLabel') + ' *'" prepend-icon="fas fa-user-tie"
                  outlined item-value="id" item-text="name"
                  :items="customerList" :loading="isLoading"
                  :rules="currentCustomerRules" @change="changeCustomer"
                )
              v-col.pb-0(cols="12")
                v-select(
                  v-model="group"
                  append-icon="fas fa-chevron-down" :label="$t('addBoarderDialog.boarderGroupFieldLabel') + ' *'"
                  outlined item-value="id" item-text="name" prepend-icon="fas fa-house-user"
                  :items="filteredGroupList"
                  :loading="isLoading" :rules="currentBoarderGroupRules" :disabled="boarderGroupSelectorDisabled"
                )
      v-card-actions
        v-row.ma-0
          v-btn(color="primary" text :disabled="saveInProgress" @click="onCloseButtonClick") {{ $t('addBoarderDialog.closeButtonLabel') }}
          v-spacer
          v-btn(color="primary" @click="onRemoveFromArchiveButtonClick" :disabled="!isForm2Valid" :loading="saveInProgress") {{ $t('boarderManagementPage.removeFromArchiveButtonLabel') }}



</template>

<script lang="ts">
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Customer from "@/model/customer/Customer";
import {TranslateResult} from "vue-i18n";
import i18n from "@/i18n";
import BoarderGroup from "@/model/boarder/BoarderGroup";

function valueIsRequired (v: string): boolean | TranslateResult {
  return !!v || i18n.t('validation.valueIsRequired')
}

@Component({
  components: {
  }
})
export default class RemoveFromArchiveDialog extends Vue {

  $refs!: {
    form: Vue & {
      validate(): boolean,
      resetValidation(): boolean
    }
  }

  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({ type: Boolean, default: false }) readonly saveInProgress!: boolean
  @Prop({ type: Object, default: false }) readonly selectedBoarder!: any
  @Prop({ type: Array, default: false }) readonly boarderGroupList!: BoarderGroup[]
  @Prop({ type: Array, default: false }) readonly customerList!: Customer[]



  private snackbar: boolean = false
  private snackbarMessage: string = ''
  private snackbarColor: string = ''
  private isForm2Valid: boolean = false
  private customer: number | null  = null
  private group: number | null  = null
  private isLoading: boolean = false
  private currentCustomerRules = [
    valueIsRequired
  ]
  private currentBoarderGroupRules = [
    valueIsRequired
  ]

  get filteredGroupList(): BoarderGroup[] {
    return this.boarderGroupList.filter((g) => g.customer?.id === this.customer)

  }

  get boarderGroupSelectorDisabled (): boolean {
    return !this.selectedBoarder.customer.id
  }

  onRemoveFromArchiveButtonClick () {
    this.$emit('save', this.group)
  }

  onCloseButtonClick() {
    this.$emit('close')
  }

  changeCustomer () {
    this.group = null
  }

  mounted() {
    this.customer = this.selectedBoarder.customer.id
    this.group = this.selectedBoarder.boarderGroupCollection[0].id
  }

}

</script>

<style lang="stylus" scoped>

</style>